import { CustomCalendar } from 'components/CustomCalendar'
import React from 'react'
import { useSmartNavigateLegacy as useNavigate } from 'components/SmartLink'
import { GetFormat, useGet } from 'sharedKernel/api'
import { Challenge } from 'data/contracts'
import { Loading } from 'components/loading'

export const HubCompanyCalendarPage = ({ ...props }): JSX.Element => {
  const navigate = useNavigate()

  const request: GetFormat = {
    url: 'v1/hub/company/challenge?page=1'
  }

  const { data, isFetching, refetch } = useGet<Challenge[]>(request, 'company-challenges')
  const renderResponse = (): JSX.Element => {
    if (isFetching) {
      return (
          <Loading />
      )
    }

    return (
        <>
            <CustomCalendar challengeList={data.rows}/>
        </>
    )
  }
  return <>{renderResponse()}</>
}
